import React from 'react'

import { IconPropsType } from '../types'

const GoogleChromeBrowserIcon = (props: IconPropsType) => {
   const { width = 28, height = 28, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 28 28'
         fill='none'
         {...rest}
      >
         <g clip-path='url(#clip0_9788_738)'>
            <path
               d='M14 20.9961C17.866 20.9961 21 17.8621 21 13.9961C21 10.1301 17.866 6.99609 14 6.99609C10.134 6.99609 7 10.1301 7 13.9961C7 17.8621 10.134 20.9961 14 20.9961Z'
               fill='white'
            />
            <path
               d='M14 7.00003H26.1224C24.894 4.87167 23.1269 3.10423 20.9988 1.87544C18.8706 0.646657 16.4565 -0.000171424 13.9991 3.40782e-08C11.5417 0.000171493 9.12763 0.647336 6.99967 1.87642C4.87171 3.10551 3.10486 4.87319 1.87677 7.00172L7.93795 17.5L7.94338 17.4986C7.3268 16.4354 7.00141 15.2283 7.00003 13.9992C6.99865 12.7701 7.32132 11.5624 7.93551 10.4978C8.5497 9.43311 9.43371 8.5492 10.4984 7.93512C11.5631 7.32105 12.7709 6.99851 14 7.00003Z'
               fill='url(#paint0_linear_9788_738)'
            />
            <path
               d='M14.0002 19.5413C17.0607 19.5413 19.5418 17.0603 19.5418 13.9997C19.5418 10.9391 17.0607 8.45801 14.0002 8.45801C10.9396 8.45801 8.4585 10.9391 8.4585 13.9997C8.4585 17.0603 10.9396 19.5413 14.0002 19.5413Z'
               fill='#1A73E8'
            />
            <path
               d='M20.0617 17.5018L14.0006 28.0001C16.458 28.0005 18.8721 27.3538 21.0003 26.1252C23.1285 24.8966 24.8958 23.1293 26.1243 21.001C27.3529 18.8727 27.9994 16.4585 27.999 14.0011C27.9985 11.5437 27.3511 9.12977 26.1218 7.00195H13.9995L13.998 7.00738C15.2272 7.00501 16.4352 7.32671 17.5003 7.94006C18.5654 8.55341 19.45 9.43672 20.065 10.501C20.6799 11.5652 21.0033 12.7727 21.0028 14.0018C21.0022 15.2309 20.6776 16.4382 20.0617 17.5018Z'
               fill='url(#paint1_linear_9788_738)'
            />
            <path
               d='M7.93835 17.5022L1.87716 7.00391C0.648152 9.13191 0.00106815 11.546 0.000976572 14.0034C0.000884992 16.4608 0.647789 18.8749 1.87664 21.003C3.10549 23.1311 4.87298 24.8981 7.00137 26.1265C9.12977 27.3548 11.544 28.0011 14.0015 28.0004L20.0626 17.5021L20.0587 17.4981C19.4462 18.5637 18.5636 19.449 17.4998 20.0648C16.4361 20.6805 15.2288 21.005 13.9997 21.0054C12.7706 21.0058 11.5631 20.6822 10.499 20.0671C9.4348 19.4521 8.55158 18.5674 7.93835 17.5022Z'
               fill='url(#paint2_linear_9788_738)'
            />
         </g>
         <defs>
            <linearGradient
               id='paint0_linear_9788_738'
               x1='1.87677'
               y1='8.75003'
               x2='26.1224'
               y2='8.75003'
               gradientUnits='userSpaceOnUse'
            >
               <stop stop-color='#D93025' />
               <stop offset='1' stop-color='#EA4335' />
            </linearGradient>
            <linearGradient
               id='paint1_linear_9788_738'
               x1='12.0879'
               y1='27.813'
               x2='24.2108'
               y2='6.81564'
               gradientUnits='userSpaceOnUse'
            >
               <stop stop-color='#FCC934' />
               <stop offset='1' stop-color='#FBBC04' />
            </linearGradient>
            <linearGradient
               id='paint2_linear_9788_738'
               x1='15.5156'
               y1='27.1263'
               x2='3.39272'
               y2='6.12891'
               gradientUnits='userSpaceOnUse'
            >
               <stop stop-color='#1E8E3E' />
               <stop offset='1' stop-color='#34A853' />
            </linearGradient>
            <clipPath id='clip0_9788_738'>
               <rect width='28' height='28' fill='white' />
            </clipPath>
         </defs>
      </svg>
   )
}
export default GoogleChromeBrowserIcon
